<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Danh sách học sinh</div>
    </div>

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <StudentFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView />
    </div>
    <v-card v-else outlined class="elevation-0">
      <StudentTable
        :query="query"
        :subjects="subjects"
        :rooms="rooms"
        :type="type"
        :grade="grade"
        :subjectGroups="subjectGroups"
        :products="products"
      />
    </v-card>
  </div>
</template>
<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import StudentFilter from '@/modules/exam/StudentFilter.vue'
import StudentTable from '@/modules/exam/StudentTable.vue'

export default {
  components: {
    StudentBlankView,
    StudentFilter,
    StudentTable
  },
  data() {
    return {
      action: {
        state: 'select'
      },
      subjects: [],
      rooms: [],
      subjectGroups: [],
      products: [],
      query: {},
      type: '',
      grade: ''
    }
  },
  computed: {},
  methods: {
    onFilterChanged(params, subjects, rooms, type, grade, subjectGroups, products) {
      this.action.state = 'filtered'
      this.query = params
      this.subjects = subjects
      this.rooms = rooms
      this.type = type
      this.grade = grade
      this.subjectGroups = subjectGroups
      this.products = products
    }
  }
}
</script>

<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
